<template>
  <div
    class="p-m-auto"
    :style="{ width: allImages.length > 1 ? '80%' : '100%', height: '100%' }"
  >
    <div class="p-d-flex p-jc-end">
      <!-- <span>{{ item.ImgID }}</span> -->
      <span>{{ __("Attached on") }}: {{ item.TheDate }}</span>
    </div>
    <div class="p-mt-2">
      <i-img
        :img="item.PathImg.replace('public', 'thumb')"
        @showImg="showBigImg(item)"
        :newImage="item.ImgID == newImageID ? newImage : null"
      ></i-img>
    </div>
    <div class="p-my-4" v-if="item.Subject != '' && item.Subject !== undefined">
      <div>{{ __("Subject") }}:</div>
      <label>{{ item.Subject }}</label>
    </div>
  </div>

  <p-img
    v-if="showImg"
    :imgPath="showImg"
    :openModal="true"
    @return="showImg = null"
    :allImages="allImagesLocal"
  />

  <i-override-dialog
    rtl
    modal
    dismissableMask
    v-model:visible="showModal"
    :title="__('Update Image Subject')"
  >
    <div class="p-d-flex p-flex-column p-jc-center">
      <div>{{ __("Subject") }}:</div>
      <!-- {{ item.ImgID }} -->
      <p-vue-textarea
        :autoResize="true"
        rows="4"
        class="p-inputtext--alt"
        v-model="message"
      />
    </div>
    <div class="p-d-flex p-jc-end p-mt-2">
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Save')"
        @click="update"
      />
    </div>
  </i-override-dialog>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import PImg from "@/components/partials/p-img";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n";

export default {
  components: {
    PImg,
  },
  props: {
    item: {
      type: Object,
    },
    allImages: Array,
    newImage: String,
    newImageID: Number,
  },
  emits: ["reload"],
  data() {
    return {
      message: "",
      isShowLoading: true,
      showImg: null,
      allImagesLocal: [],
      showModal: false,
    };
  },
  mounted() {
    this.message = this.item.Subject;
  },
  methods: {
    showBigImg(image) {
      this.showImg = image.PathImg;
      // if (this.newImageID == image.ImgID){

      // }
      this.allImagesLocal = this.allImages.map((img) => {
        return { imgPath: img.PathImg, imgSubject: img.Subject };
      });
    },
    update() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("ImgID", this.item.ImgID, apiPType.Int),
        apiParam("Subject", this.message, apiPType.NVarChar),
      ];
      callProc("WorkerApp_UpdateProblemsPicture", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_UpdateProblemsPicture", result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("Image saved successfully"));

            setTimeout(() => {
              this.$emit("reload", "WorkerApp_GetImagesToServiceCall", true);
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateProblemsPicture");
        });
    },
    deleteImageInDB() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("ImgID", this.item.ImgID, apiPType.Int)];
      callProc("WorkerApp_DeleteProblemsPicture", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_DeleteProblemsPicture", result);
          if (result.procReturnValue == 0) {
            this.$emit("reload", "WorkerApp_GetImagesToServiceCall", false);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteProblemsPicture");
        });
    },
  },
  computed: {
    Delete() {
      return this.item.Delete;
    },
    SaveEditData() {
      return this.item.SaveEditData;
    },
    IsEdit() {
      return this.item.IsEdit;
    },
    ...mapState({
      sessionToken: (state) => state.api.sessionToken,
    }),
  },
  watch: {
    Delete() {
      if (this.Delete) this.deleteImageInDB();
    },
    SaveEditData() {
      if (this.SaveEditData) this.update();
    },
    IsEdit() {
      if (this.IsEdit) this.showModal = true;
      else this.showModal = false;
    },
  },
};
</script>

<style scoped>
/* img {
  max-width: 150px;
} */

.p-inputtextarea {
  width: 100%;
}
</style>
